<template>
  <div v-if="!loading" class="plans-card">
    <plans-button v-if="!hasPlans" @button-click="goToPlanAheadPage"/>
    <plans-section v-else :plans="plans"/>
  </div>
</template>

<script>
import router from '@/router';
import PlansButton from '@/pages/responsive-pages/authenticated/navigation-pages/plan-ahead/plans-card/PlansButton';
import { mapState, mapGetters, mapActions } from 'vuex';
import PlansSection from '@/pages/responsive-pages/authenticated/navigation-pages/plan-ahead/plans-card/plans-section/PlansSection';
import Segment from '@/Segment';

export default {
  name: 'PlansCard',
  components: {
    PlansSection,
    PlansButton,
  },
  async created() {
    await this.initPlans();
    await this.initPlansSuggestions();
    Segment.trackUserGot('PlanAhead_FeatureFlagOn', { hasPlans: this.hasPlans });
    this.loading = false;
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState('planAhead', ['plans']),
    ...mapGetters('planAhead', ['hasPlans']),
  },
  methods: {
    ...mapActions('planAhead', ['initPlans', 'initPlansSuggestions']),
    goToPlanAheadPage() {
      router.push({ path: '/plan-ahead' });
    },
  },
};
</script>

<style scoped lang="scss">
.plans-card {
  .separator {
    height: 2px;
    margin-top: 22px;
  }
}
</style>
